import { CALL_API } from "../../middlewares/api";

export const BORROWER_WITHDRAW_LIST_GET_REQUEST =
  "BORROWER_WITHDRAW_LIST_GET_REQUEST";
export const BORROWER_WITHDRAW_LIST_GET_SUCCESS =
  "BORROWER_WITHDRAW_LIST_GET_SUCCESS";
export const BORROWER_WITHDRAW_LIST_GET_ERROR =
  "BORROWER_WITHDRAW_LIST_GET_ERROR";

export function get_borrower_withdrawal_orders() {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loanstep/get-borrower-withdrawal-orders?pending=true",
      authenticatedRequest: true,
      types: [
        BORROWER_WITHDRAW_LIST_GET_REQUEST,
        BORROWER_WITHDRAW_LIST_GET_SUCCESS,
        BORROWER_WITHDRAW_LIST_GET_ERROR,
      ],
    },
  };
}

export function get_borrower_withdrawal_orders_by_account(accountId) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loanstep/get-borrower-withdrawal-orders?borrowerId=" +
        accountId,
      authenticatedRequest: true,
      types: [
        BORROWER_WITHDRAW_LIST_GET_REQUEST,
        BORROWER_WITHDRAW_LIST_GET_SUCCESS,
        BORROWER_WITHDRAW_LIST_GET_ERROR,
      ],
    },
  };
}

export const APPROVE_BORROWER_WITHDRAWAL_ORDER_REQUEST =
  "APPROVE_BORROWER_WITHDRAWAL_ORDER_REQUEST";
export const APPROVE_BORROWER_WITHDRAWAL_ORDER_SUCCESS =
  "APPROVE_BORROWER_WITHDRAWAL_ORDER_SUCCESS";
export const APPROVE_BORROWER_WITHDRAWAL_ORDER_ERROR =
  "APPROVE_BORROWER_WITHDRAWAL_ORDER_ERROR";

export function approve_withdrawal_order(orderId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/confirm-borrower-withdrawal-order",
      method: "POST",
      data: { Id: orderId },
      authenticatedRequest: true,
      types: [
        APPROVE_BORROWER_WITHDRAWAL_ORDER_REQUEST,
        APPROVE_BORROWER_WITHDRAWAL_ORDER_SUCCESS,
        APPROVE_BORROWER_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}

export function approve_withdrawal_orders(list) {
  return (dispatch) => {
    const orderId = list.pop();
    if (list.length > 0) {
      dispatch(approve_withdrawal_orders(list));
    }
    dispatch(approve_withdrawal_order(orderId));
  };
}

export const SWAP_BORROWER_DEPOSIT_DATA = "SWAP_BORROWER_DEPOSIT_DATA";

export function swap_data() {
  return {
    type: SWAP_BORROWER_DEPOSIT_DATA,
  };
}
